import { Button, MessageBar, MessageBarActions, MessageBarBody, makeStyles } from '@fluentui/react-components';
import type { HrWorkflowView, Person } from '@vigeo/shared';
import { tokens } from '@vigeo/ui';
import { undeliveredNotice } from '../model.js';
import { HandOverLinkButton, HandOverLinkDialog, HandOverLinkError, useHandOverLink } from './HandOverLink.js';

const useStyles = makeStyles({ stack: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalS } });

/**
 * What happened to the offer email, kept on screen after the send replaced the Send screen.
 *
 * Delivered: one sentence. Not delivered: the reason in plain words, and a "Get the link and code"
 * action so HR is never left holding a warning with nothing to do about it (#458).
 */
export function DeliveryNotice({ person, delivery, canEdit, onDismiss }: {
  readonly person: Person;
  readonly delivery: NonNullable<HrWorkflowView['offerDelivery']>;
  readonly canEdit: boolean;
  readonly onDismiss?: () => void;
}) {
  const styles = useStyles();
  const first = person.name.preferredName || person.name.givenName;
  const link = useHandOverLink(person, false);
  return (
    <div role="group" aria-label="Offer delivery" className={styles.stack}>
      <MessageBar intent={delivery.delivered ? 'success' : 'warning'}>
        <MessageBarBody>
          {delivery.delivered
            ? `The offer is in ${first}’s portal and the email went to ${delivery.maskedTo}.`
            : undeliveredNotice(first, delivery.reason)}
        </MessageBarBody>
        <MessageBarActions>
          {delivery.delivered || !canEdit ? null : <HandOverLinkButton handOver={link} />}
          {onDismiss === undefined ? null : <Button onClick={onDismiss}>Dismiss</Button>}
        </MessageBarActions>
      </MessageBar>
      {delivery.delivered ? null : <><HandOverLinkError handOver={link} /><HandOverLinkDialog handOver={link} firstName={first} /></>}
    </div>
  );
}
